// Runtime REACT_APP_* values (window._env_) come from the App Service application
// settings via server.js and public/env-config.js; they override whatever was
// inlined at build time, so URLs can change per environment without a rebuild.
const env = {
  ...process.env,
  ...(typeof window !== 'undefined' ? window._env_ : undefined),
};

const config = {
  SENTRY_DSN: env.REACT_APP_SENTRY_DSN || '',
  SENTRY_SAMPLE_RATE: +env.REACT_APP_SENTRY_SAMPLE_RATE || 1.0,
  AUTH_URL: env.REACT_APP_AUTH_URL || 'https://localhost:7501',
  API_URL: env.REACT_APP_API_URL || 'https://localhost:7500/accounts',
  //VOLUNTEER_APP_URL: env.REACT_APP_VOLUNTEER_APP_URL || 'https://localhost:3000',
  ADMIN_APP_URL: env.REACT_APP_ADMIN_APP_URL || 'https://localhost:3001',
  WS_APP_URL: env.REACT_APP_WS_URL || 'https://localhost:9500',
  ORGANIZATION_COOKIE_DOMAIN: env.REACT_APP_ORGANIZATION_COOKIE_DOMAIN || 'localhost',
  ORGANIZATION_COOKIE_NAME: env.REACT_APP_ORGANIZATION_COOKIE_NAME || 'aplanet_organization_development',
  GOOGLE_MAPS_KEY: env.REACT_APP_GOOGLE_MAPS_KEY || '',
  POSTHOG_URL: env.REACT_APP_POSTHOG_URL || '',
  POSTHOG_KEY: env.REACT_APP_POSTHOG_KEY || '',
  INTERCOM_APP_ID: env.REACT_APP_INTERCOM_APP_ID || null,
}

export default config;
